module.exports = __webpack_public_path__ + "static/paul-north-7d763f1aaf679b9d950a25a9e8361d75.png";